import { Link } from "react-router-dom";
import type { Category } from "@/types/video";

interface HeroIntroProps {
  categories: Category[];
}

const stats = [
  { value: "12,800+", label: "收录视频" },
  { value: "36", label: "明星追踪专题" },
  { value: "每日更新", label: "热点速递" },
];

export default function HeroIntro({ categories }: HeroIntroProps) {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-6 md:py-10">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-flashlight-fill"></i>
              今日热点已更新 18 条
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl lg:text-[42px]">
              黑料视频 · 每条热闻都有迹可循
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              我们用视频把娱乐八卦与网络热点讲清楚：明星动态、刷屏事件、热门片段与深度解析，几分钟看懂前因后果，不做无根据的猜测。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="flex items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3.5 py-1.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
                >
                  <i className={`${cat.icon} text-accent-500`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid w-full grid-cols-3 gap-3 lg:w-auto lg:shrink-0">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-100 px-4 py-5 text-center lg:min-w-[130px]"
              >
                <p className="font-heading text-lg font-black text-primary-600 md:text-xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}